/* eslint-disable react-hooks/exhaustive-deps */
import LoadingContent from 'components/LoadingContent';
import { useFormik } from 'formik';
import React from 'react';
import TopProcessBar from 'screen/selectCollege/TopProcessBar';
import { Container, Form, Spinner, Button } from 'react-bootstrap';
import { useAppDispatch, useAppSelector } from 'app/hooks';
import { useHistory } from 'react-router-dom';
import { routers } from 'router/router';
import { logout } from 'app/basicInformationSlice/basicInformationSlice';
import CalculateOutlinedIcon from '@mui/icons-material/CalculateOutlined';
import CheckboxInput from 'components/input/CheckboxInput';
import DatePickerInput from 'components/input/DatePicker';
import SelectInput from 'components/input/SelectInput';
import ReuseFieldScoreAndDate from './components/ReuseFieldScoreAndDate';
import GroupRadioButton from 'components/input/GroupRadioButton';
import { getIELTSAndPTE, updateIELTSAndPTE } from 'app/testingSlice/testingSlice';
import { optionValues } from 'components/helper/helper';
import { HtmlTooltip } from 'screen/selectCollege/SelecCollegePage';
import { Typography } from '@mui/material';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import YesNoSwitch from 'components/input/YesNoSwitch';
import { debounce } from 'lodash';
import Grid from '@mui/joy/Grid';
import { getAccessToken, getUserId, removeAccessToken, removeUserId } from 'utils/sessionStorage';
//import Cookies from 'js-cookie';
//import { authenticateSettings } from 'components/helper/appConfig';


interface Props {}

const IELTSAndPTE = (props: Props) => {
  const [loading, setLoading] = React.useState(false);
  const [isMobile, setIsMobile] = React.useState<boolean>(window.innerWidth <= 768);
  const testing = useAppSelector((store) => store.testing);
  const dispatch = useAppDispatch();
  const history = useHistory();
  let studentId = getUserId();
  let token = getAccessToken();

  const formik = useFormik({
    initialValues: {
      is_not_required_pte_test: false,
      number_of_times_taken_pte_test: 0,
      number_of_future_pte_test_expect: 0,
      future_pte_testing_date: '',
      pte_highest_listening_score: '',
      pte_listening_date_taken: '',
      pte_highest_reading_score: '',
      pte_reading_date_taken: '',
      pte_highest_speaking_score: '',
      pte_speaking_date_taken: '',
      pte_highest_writing_score: '',
      pte_writing_date_taken: '',
      pte_highest_grammar_score: '',
      pte_grammar_date_taken: '',
      pte_highest_oral_fluency_score: '',
      pte_oral_fluency_date_taken: '',
      pte_highest_pronunciation_score: '',
      pte_pronunciation_date_taken: '',
      pte_highest_spelling_score: '',
      pte_spelling_date_taken: '',
      pte_highest_vocabulary_score: '',
      pte_vocabulary_date_taken: '',
      pte_highest_written_discourse_score: '',
      pte_written_discourse_date_taken: '',
      is_not_required_ielts: false,
      number_of_times_taken_ielts: 0,
      future_ielts_testing_date: '',
      number_of_future_ielts_expect: '0',
      ielts_highest_listening_score: '',
      ielts_listening_date_taken: '',
      ielts_highest_reading_score: '',
      ielts_reading_date_taken: '',
      ielts_highest_speaking_score: '',
      ielts_speaking_date_taken: '',
      ielts_highest_writing_score: '',
      ielts_writing_date_taken: '',
      ielts_highest_overall_band_score: '',
      ielts_overall_band_score_date_taken: '',
      // New field
      ielts_received_score: '',
      ielts_listening_score: '',
      ielts_reading_score: '',
      ielts_speaking_score: '',
      ielts_writing_score: '',
      ielts_overall_band_score: '',
      ielts_plan_on_retake_test: '',
    },
    onSubmit: async (values) => {
      const newValues = {
        ...values,
        student_id: studentId,
      };
      await dispatch(updateIELTSAndPTE(newValues));
    },
  });

  const handleLogout = () => {
    dispatch(logout());
    removeAccessToken();
    removeUserId();
    history.push(routers.login.path);
  };

  const handleContinue = () => {
    formik.handleSubmit();
    const nextRoute = Object.keys(testing.roleTest).find(
      (key, index) =>
        index > Object.keys(testing.roleTest).indexOf('ieltsAndPte') &&
        testing.roleTest[key] === true
    );
    history.push(nextRoute ? routers?.[nextRoute]?.path : routers.activities.path);
  };

  const getDetail = async () => {
    studentId = getUserId();
    token = getAccessToken();
    if (token && studentId) {
      setLoading(true);
      let res = await dispatch(getIELTSAndPTE(studentId));
      const dataLoaded: any = res.payload;
      if (dataLoaded) {
        const values: any = {
          ...dataLoaded,
          number_of_future_ielts_expect: dataLoaded.number_of_future_ielts_expect.toString(),
        };
        formik.setValues(values);
      }
      setLoading(false);
      formik.setStatus('idle');
    } else {
      handleLogout();
    }
  };

  React.useEffect(() => {
    getDetail();
  }, []);

  React.useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  // Auto save function ==========
  const notInitialRender = React.useRef(false);
  React.useEffect(() => {
    debounceSaving();
  }, [formik.values]);
  const debounceSaving = React.useCallback(
    debounce(() => {
      if (notInitialRender.current) {
        if (!loading) formik.handleSubmit();
      } else {
        notInitialRender.current = true;
      }
    }, 1500),
    []
  );
  // Auto save function ==========
  return loading ? (
    <LoadingContent />
  ) : (
    <>
      <TopProcessBar
        stepProcess={[
          { title: 'PTE', percentOnProcess: 30 },
          { title: 'IELTS', percentOnProcess: 70 },
        ]}
        title="Standardized Testing"
        process={1}
        icon={<CalculateOutlinedIcon />}
        isMobile={isMobile}
      />

      <Container 
        className={`main-container gm-basic-info-page ${isMobile ? 'p-mobile-2' : ''}`}
        style={{
          paddingLeft: isMobile ? '12px' : undefined,
          paddingRight: isMobile ? '12px' : undefined,
          paddingTop: isMobile ? '120px' : undefined,
          maxWidth: '100vw',
          overflow: 'hidden'
        }}
      >
        <div className={`gm-section-card ${isMobile ? 'p-mobile-2' : 'px-4 py-4'}`}>
          <Form
            style={{ 
              maxWidth: isMobile ? '100%' : '900px',
              width: '100%'
            }}
            onSubmit={formik.handleSubmit}
            className="gm-form-grid"
          >
            <div className={`gm-section-title ${isMobile ? 'mb-2' : 'mb-4'}`}>
              <span style={{ fontSize: isMobile ? '18px' : '20px', fontWeight: 600 }}>
                IELTS & PTE Academic Tests
              </span>
            </div>
            <Grid container spacing={isMobile ? 1 : 2} className="gm-form-fields">
              <Grid xs={12}>
                <div className="my-2">Let's organize all your IELTS and PTE Academic test information!</div>
              </Grid>

              {/* PTE Section */}
              <Grid xs={12}>
                <div className="gm-section-subtitle mb-3">
                  <HtmlTooltip
                    title={
                      <React.Fragment>
                        <Typography className="fs-6 text-dark my-2 fw-bold">
                          <InfoOutlinedIcon fontSize="small" className="mx-1" />
                          PTE Academic Tests
                        </Typography>
                        <div className="d-flex flex-wrap text-field-light">
                          For international students - the testing policies for specific colleges can
                          vary. Check with the colleges you intend to apply to in advance to determine the
                          tests, if any, you'll need to take. Note, be sure to do in your 1st or 2nd year
                          of high school so you can plan accordingly when to take your test(s).
                        </div>
                      </React.Fragment>
                    }
                    placement="right-start"
                  >
                    <div className="text-field-mid fs-4 mb-3 fw-bold">PTE Academic Tests</div>
                  </HtmlTooltip>
                </div>
              </Grid>

              <Grid xs={12}>
                <CheckboxInput
                  onChange={formik.handleChange}
                  name="is_not_required_pte_test"
                  values={formik.values.is_not_required_pte_test}
                  label="I'm a domestic student or am not required to take the PTE Academic Tests."
                />
              </Grid>

              <Grid xs={12} md={6}>
                <SelectInput
                  form={formik}
                  disabled={formik.values.is_not_required_pte_test}
                  label="Number of times you have already taken the PTE Academic Test*"
                  option={optionValues(Array.from(Array(6).keys()))}
                  name="number_of_times_taken_pte_test"
                  values={formik.values.number_of_times_taken_pte_test}
                  onChange={formik.handleChange}
                />
              </Grid>

              <Grid xs={12} md={6}>
                <SelectInput
                  form={formik}
                  disabled={formik.values.is_not_required_pte_test}
                  label="Number of future PTE Academic Test sittings you expect*"
                  option={[{ value: '0' }, { value: '1' }, { value: '2' }, { value: '3' }]}
                  name="number_of_future_pte_test_expect"
                  values={formik.values.number_of_future_pte_test_expect}
                  onChange={formik.handleChange}
                />
              </Grid>

              <Grid xs={12}>
                <DatePickerInput
                  disabled={formik.values.is_not_required_pte_test}
                  label="Future testing date *"
                  name="future_pte_testing_date"
                  values={formik.values.future_pte_testing_date}
                  onChange={(values) => formik.setFieldValue('future_pte_testing_date', values)}
                />
              </Grid>

              <Grid xs={12}>
                <ReuseFieldScoreAndDate
                  selectOptions={optionValues(
                    Array.from(Array(81).keys()).map((item) => item + 10)
                  )}
                  disabled={formik.values.is_not_required_pte_test}
                  formik={formik}
                  isMobile={isMobile}
                  arrayName={[
                    {
                      fieldName: 'pte_highest_listening_score',
                      dateName: 'pte_listening_date_taken',
                      label: 'listening',
                    },
                    {
                      fieldName: 'pte_highest_reading_score',
                      dateName: 'pte_reading_date_taken',
                      label: 'reading',
                    },
                    {
                      fieldName: 'pte_highest_speaking_score',
                      dateName: 'pte_speaking_date_taken',
                      label: 'speaking',
                    },
                    {
                      fieldName: 'pte_highest_writing_score',
                      dateName: 'pte_writing_date_taken',
                      label: 'writing',
                    },
                    {
                      fieldName: 'pte_highest_grammar_score',
                      dateName: 'pte_grammar_date_taken',
                      label: 'grammer',
                    },
                    {
                      fieldName: 'pte_highest_oral_fluency_score',
                      dateName: 'pte_oral_fluency_date_taken',
                      label: 'oral fluency',
                    },
                    {
                      fieldName: 'pte_highest_pronunciation_score',
                      dateName: 'pte_pronunciation_date_taken',
                      label: 'pronunciation',
                    },
                    {
                      fieldName: 'pte_highest_spelling_score',
                      dateName: 'pte_spelling_date_taken',
                      label: 'spelling',
                    },
                    {
                      fieldName: 'pte_highest_vocabulary_score',
                      dateName: 'pte_vocabulary_date_taken',
                      label: 'vocabulary',
                    },
                    {
                      fieldName: 'pte_highest_written_discourse_score',
                      dateName: 'pte_written_discourse_date_taken',
                      label: 'written discourse',
                    },
                  ]}
                />
              </Grid>

              {/* IELTS Section */}
              <Grid xs={12}>
                <div className="border-top pt-4 mt-4">
                  <div className="gm-section-subtitle mb-3">
                    <HtmlTooltip
                      title={
                        <React.Fragment>
                          <Typography className="fs-6 text-dark my-2 fw-bold">
                            <InfoOutlinedIcon fontSize="small" className="mx-1" />
                            IELTS
                          </Typography>
                          <div className="d-flex flex-wrap text-field-light">
                            For international students - the testing policies for specific colleges can
                            vary. Check with the colleges you intend to apply to in advance to determine the
                            tests, if any, you'll need to take. Note, be sure to do in your 1st or 2nd year
                            of high school so you can plan accordingly when to take your test(s).
                          </div>
                        </React.Fragment>
                      }
                      placement="right-start"
                    >
                      <div className="text-field-mid fs-4 mb-3 fw-bold">IELTS</div>
                    </HtmlTooltip>
                  </div>
                </div>
              </Grid>

              <Grid xs={12}>
                <CheckboxInput
                  onChange={formik.handleChange}
                  name="is_not_required_ielts"
                  values={formik.values.is_not_required_ielts}
                  label="I'm a domestic student or am not required to take the IELTS."
                />
              </Grid>

              <Grid xs={12} md={6}>
                <SelectInput
                  form={formik}
                  label="Number of times you have already taken the IELTS*"
                  option={optionValues(Array.from(Array(6).keys()))}
                  name="number_of_times_taken_ielts"
                  values={formik.values.number_of_times_taken_ielts}
                  onChange={formik.handleChange}
                  disabled={formik.values.is_not_required_ielts}
                />
              </Grid>

              <Grid xs={12}>
                <YesNoSwitch
                  className="mb-3"
                  name="ielts_received_score"
                  label="Have you received your scores yet? *"
                  values={formik.values.ielts_received_score}
                  onChange={formik.handleChange}
                />
              </Grid>

              <Grid xs={12}>
                <ReuseFieldScoreAndDate
                  selectOptions={optionValues(Array.from(Array(19).keys()).map((item) => item / 2))}
                  disabled={formik.values.is_not_required_ielts}
                  formik={formik}
                  isMobile={isMobile}
                  arrayName={[
                    {
                      fieldName: 'ielts_highest_listening_score',
                      dateName: 'ielts_listening_date_taken',
                      label: 'listening',
                    },
                    {
                      fieldName: 'ielts_highest_reading_score',
                      dateName: 'ielts_reading_date_taken',
                      label: 'reading',
                    },
                    {
                      fieldName: 'ielts_highest_speaking_score',
                      dateName: 'ielts_speaking_date_taken',
                      label: 'speaking',
                    },
                    {
                      fieldName: 'ielts_highest_writing_score',
                      dateName: 'ielts_writing_date_taken',
                      label: 'writing',
                    },
                    {
                      fieldName: 'ielts_highest_overall_band_score',
                      dateName: 'ielts_overall_band_score_date_taken',
                      label: 'IELTS overall band',
                    },
                  ]}
                />
              </Grid>

              <Grid xs={12}>
                <div className="text-field-mid fs-5 mb-3 fw-bold">Current Score</div>
              </Grid>

              <Grid xs={12} md={6}>
                <SelectInput
                  name="ielts_listening_score"
                  label="Listening*"
                  values={formik.values.ielts_listening_score}
                  onChange={formik.handleChange}
                  option={optionValues(Array.from(Array(19).keys()).map((item) => item / 2))}
                />
              </Grid>

              <Grid xs={12} md={6}>
                <SelectInput
                  name="ielts_reading_score"
                  label="Reading*"
                  values={formik.values.ielts_reading_score}
                  onChange={formik.handleChange}
                  option={optionValues(Array.from(Array(19).keys()).map((item) => item / 2))}
                />
              </Grid>

              <Grid xs={12} md={6}>
                <SelectInput
                  name="ielts_writing_score"
                  label="Writing*"
                  values={formik.values.ielts_writing_score}
                  onChange={formik.handleChange}
                  option={optionValues(Array.from(Array(19).keys()).map((item) => item / 2))}
                />
              </Grid>

              <Grid xs={12} md={6}>
                <SelectInput
                  name="ielts_speaking_score"
                  label="Speaking*"
                  values={formik.values.ielts_speaking_score}
                  onChange={formik.handleChange}
                  option={optionValues(Array.from(Array(19).keys()).map((item) => item / 2))}
                />
              </Grid>

              <Grid xs={12}>
                <SelectInput
                  name="ielts_overall_band_score"
                  label="Overall Band Score"
                  values={formik.values.ielts_overall_band_score}
                  onChange={formik.handleChange}
                  option={optionValues(Array.from(Array(19).keys()).map((item) => item / 2))}
                />
              </Grid>

              <Grid xs={12}>
                <YesNoSwitch
                  className="mb-3"
                  label="Do you plan on retaking this test?*"
                  name="ielts_plan_on_retake_test"
                  values={formik.values.ielts_plan_on_retake_test}
                  onChange={formik.handleChange}
                />
              </Grid>

              {formik.values.ielts_plan_on_retake_test === 'true' && (
                <>
                  <Grid xs={6}>
                    <GroupRadioButton
                      label="Number of future IELTS sittings you expect*"
                      options={[{ value: '0' }, { value: '1' }, { value: '2' }, { value: '3' }]}
                      values={formik.values.number_of_future_ielts_expect}
                      onChange={formik.handleChange}
                      name="number_of_future_ielts_expect"
                      disabled={formik.values.is_not_required_ielts}
                    />
                  </Grid>
                  {formik.values.number_of_future_ielts_expect !== '0' && (
                    <Grid xs={6}>
                      <DatePickerInput
                        label="When will you retake this test? *"
                        name="future_ielts_testing_date"
                        values={formik.values.future_ielts_testing_date}
                        onChange={(values) =>
                          formik.setFieldValue('future_ielts_testing_date', values)
                        }
                        disabled={formik.values.is_not_required_ielts}
                      />
                    </Grid>
                  )}
                </>
              )}
            </Grid>

            <div className={`${isMobile ? 'my-2' : 'my-3'} d-flex ${isMobile ? 'flex-column' : 'justify-content-end'} border-top ${isMobile ? 'pt-2' : 'pt-3'}`}>
              <div className={`${isMobile ? 'w-100' : 'col col-md-6'} text-center ${isMobile ? '' : 'text-md-end'}`}>
                <div className={`d-flex ${isMobile ? 'flex-column gap-2' : 'flex-row'} justify-content-center`}>
                  <Button 
                    variant="primary" 
                    type="submit" 
                    className={`${isMobile ? 'w-100 py-3' : 'p-2 px-5 mx-2'} gm-btn-save`}
                    style={{
                      fontSize: isMobile ? '16px' : '14px',
                      minHeight: isMobile ? '44px' : 'auto'
                    }}
                  >
                    {testing.status === 'loading' ? (
                      <Spinner size="sm" animation="border" variant="light" />
                    ) : (
                      'Save'
                    )}
                  </Button>
                  <Button 
                    variant="primary" 
                    className={`${isMobile ? 'w-100 py-3' : 'p-2 px-5'} gm-btn-continue`}
                    onClick={() => handleContinue()}
                    style={{
                      fontSize: isMobile ? '16px' : '14px',
                      minHeight: isMobile ? '44px' : 'auto'
                    }}
                  >
                    Continue
                  </Button>
                </div>
              </div>
            </div>
          </Form>
        </div>
      </Container>
    </>
  );
};

export default IELTSAndPTE;
